import styled, { css } from 'styled-components';

const firstCell = css`
  width: 20%;
  text-align: left;
  padding-left: 10px;
  font-weight: 600;
  font-size: 11px;
  color: ${(props) => props.theme.timesheetsTableTextSecondaryColor};
`;

const firstCellMobile = css`
  width: 163px;
  text-align: left;
  padding-left: 10px;
  font-weight: 600;
  font-size: 11px;
  color: ${(props) => props.theme.timesheetsTableTextSecondaryColor};
`;

const middleCells = css`
  width: 7%;
  text-align: center;
  color: ${(props) => props.theme.timesheetsTableTextMainColor};
`;

const middleCellsMobile = css`
  width: 100px;
  text-align: center;
  color: ${(props) => props.theme.timesheetsTableTextMainColor};
`;

const todayCell = css`
  width: 7%;
  p {
    color: #5b5fc6;
  }
`;

const todayCellMobile = css`
  width: 100px;
  p {
    color: #5b5fc6;
  }
`;

const lastCell = css`
  width: 7%;
  text-align: left;
  padding-left: 10px;
  font-weight: 600;
  font-size: 11px;
  color: ${(props) => props.theme.timesheetsTableTextSecondaryColor};
`;

const lastCellMobile = css`
  width: 100px;
  text-align: left;
  padding-left: 10px;
  font-weight: 600;
  font-size: 11px;
  color: ${(props) => props.theme.timesheetsTableTextSecondaryColor};
`;

export const TableRowHeaderCell = styled.th<{
  firstRow: boolean;
  lastRow: boolean;
  isToday: boolean;
  isMobile: boolean;
}>`
  ${({ firstRow, lastRow, isToday, isMobile }) => {
    if (firstRow) {
      if (isMobile) {
        return firstCellMobile;
      } else {
        return firstCell;
      }
    } else if (lastRow) {
      if (isMobile) {
        return lastCellMobile;
      } else {
        return lastCell;
      }
    } else if (isToday) {
      if (isMobile) {
        return todayCellMobile;
      } else {
        return todayCell;
      }
    } else {
      if (isMobile) {
        return middleCellsMobile;
      } else {
        return middleCells;
      }
    }
  }}
  background-color: ${(props) => props.theme.timesheetsTableHeaderBackground};
  vertical-align: middle;
  font-weight: 700;
  border: 1px solid ${(props) => props.theme.timesheetsTableBorderColor};
`;

const dateText = css`
  display: none;
`;

const dateMobile = css`
  color: #8a94a6;
`;

export const TableRowHeaderCellDate = styled.p<{
  firstRow: boolean;
  lastRow: boolean;
  isMobile?: boolean;
}>`
  ${({ firstRow, lastRow, isMobile }) => {
    if (firstRow || lastRow) {
      return dateText;
    } else if (isMobile) {
      return dateMobile;
    }
  }}

  font-weight: 700;
`;

const headerText = css`
  font-weight: 600;
  font-size: 13px;
`;

const headerMobile = css`
  color: #8a94a6;
  font-weight: 700;
`;

export const TableRowHeaderCellText = styled.p<{
  firstRow: boolean;
  lastRow: boolean;
  isMobile?: boolean;
}>`
  ${({ firstRow, lastRow, isMobile }) => {
    if (firstRow || lastRow) {
      return headerText;
    } else if (isMobile) {
      return headerMobile;
    }
  }}
`;
